import { clsx } from 'clsx';

import { CopyEmailLink } from './CopyEmailLink';
import { formatLastContacted } from './lastContacted';
import { getProfileStages } from './profileStages';
import { StageTimeline } from './StageTimeline';
import { useGetSellerCustomerLastContacted } from '../../../../api/lending/lapiHooks';
import { CustomerRow } from '../../CustomersV2.types';

const ACTION_COPY = {
  business_details:
    'Remind your customer to finish submitting all of their business information',
  security: 'Remind your customer to complete their remaining security checks',
} as const;

export const OnboardingProfile = ({ row }: { row: CustomerRow }) => {
  const stage = row.application_stage.value;
  const actionCopy =
    stage === 'security' ? ACTION_COPY.security : ACTION_COPY.business_details;

  const { lastContacted } = useGetSellerCustomerLastContacted({
    buyerStateKey: row.buyer_state_key,
  });
  const lastContactedCopy = formatLastContacted(lastContacted);

  return (
    <div>
      <div className="flex flex-col gap-s bg-primary-10 px-xl py-l text-structure-100">
        <div className="text-l font-bold">Actions you can take</div>
        <div className="text-m font-reg max-1024:text-s">{actionCopy}</div>
      </div>
      {/* The contact note tints the block it shares with the link. */}
      {(lastContactedCopy !== null || row.email !== null) && (
        <div
          className={clsx(
            'rounded-xs p-l',
            lastContactedCopy !== null && 'bg-secondary-97',
          )}
        >
          {lastContactedCopy !== null && (
            <div className="flex flex-wrap items-start justify-between gap-s p-l text-s text-primary-10">
              <span className="font-bold">
                Last time we contacted this customer:
              </span>
              <span className="font-reg">{lastContactedCopy}</span>
            </div>
          )}
          {row.email !== null && (
            <div className="flex justify-end px-l">
              <CopyEmailLink email={row.email} />
            </div>
          )}
        </div>
      )}
      <StageTimeline stages={getProfileStages(row)} row={row} />
    </div>
  );
};
